module.exports = "<div class=\"controls-sidebar\">\r\n    <!-- <div *ngIf=\"isTourActive\" class=\"overlay-html\"></div> -->\r\n    <div class=\"step-controls\" >\r\n\r\n        <!-- Nav tabs -->\r\n        <app-nav-tabs></app-nav-tabs>\r\n\r\n        <!-- Tab panes -->\r\n        <app-tab-panel></app-tab-panel>\r\n\r\n    </div>\r\n\r\n    <!--footer-toolbar-->\r\n    <app-footer-toolbar></app-footer-toolbar>\r\n\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/sidebar/sidebar.component.html
// module id = ./src/app/sidebar/sidebar.component.html
// module chunks = main